import { Link } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import Breadcrumb from "@/components/base/Breadcrumb";
import { articles } from "@/mocks/articleData";

export default function ArticleListPage() {
  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: "优惠资讯" },
  ];

  return (
    <>
      <SEOHead
        title="优惠资讯 - 必赢亚洲"
        description="必赢亚洲最新优惠活动、游戏攻略、行业资讯。了解最新首存礼、返水优惠、VIP福利等精彩内容。"
        keywords="必赢亚洲优惠活动,必赢亚洲攻略,游戏技巧,优惠资讯,活动公告"
        canonicalUrl="https://www.biyingyazhou.com/articles"
        ogType="website"
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "优惠资讯 - 必赢亚洲",
          "description": "必赢亚洲最新优惠活动、游戏攻略、行业资讯",
          "url": "https://www.biyingyazhou.com/articles",
          "inLanguage": "zh-CN",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.biyingyazhou.com/" },
              { "@type": "ListItem", "position": 2, "name": "优惠资讯" },
            ],
          },
        }}
      />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>
        </div>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                优惠资讯
              </h1>
              <p className="mt-3 text-foreground-600">
                最新优惠活动、游戏攻略与行业资讯，一手掌握
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/articles/${article.id}`}
                  className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/90 text-background-50">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h2 className="text-lg font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span>{article.publishDate}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                        {article.readCount.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}